<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="流控降级-App">
            
        <div slot="extra">
            <a-button type="primary" @click="handleNewAppRiskConfig">新建</a-button>
        </div>
            <a-form layout="inline" :form="form">
                <a-form-item label="应用编码">
                    <AppAutoComplete ref="appcodeAss" :javaOnly="'1'" @onAppCodeChange="handleSearchAppcodeChange"></AppAutoComplete>
                </a-form-item>

                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key" @click="handleAppSearch">查询
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>

        <!-- 系统列表 -->
        <a-table :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" rowKey="id">
            <authedStrd slot="riskconfigs" slot-scope="text" :authedStr="text"></authedStrd>

            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <!-- <span>
                        <a-popconfirm  @confirm="() => handle_auth_delete(record)" >
                            <template slot="title">
                                <p>{{ '确认将【' + record.appcode+ '】删除？' }}</p>
                            </template>
                        <a>删除配置    </a>
                        </a-popconfirm>
                    </span> -->
                    <span>
                        <a @click="() => handleEditAppConfig(record)">全局配置</a>
                    </span>
                    <span>
                        <a @click="() => handleAppConfig(record)">服务配置</a>
                    </span>
                    <span>
                        <a-popconfirm  @confirm="() => handleDownConfig(record)" >
                            <template slot="title">
                                <p>原配置将会被覆盖，确定下发？</p>
                            </template>
                        <a>下发    </a>
                        </a-popconfirm>
                    </span>
                    
                </div>
            </template>

            
        </a-table>

        <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total"
            @change="handlePageChange" show-less-items show-quick-jumper />


        <!-- 新增编辑模态框 -->

    </div>
</template>
<script>
import authedStrd from "./tableItems";

import AppAutoComplete from '@/components/AppAutoComplete'
let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },

    {
        title: '应用编码',
        dataIndex: 'appcode',
        align: 'center',
        scopedSlots: { customRender: 'appcode' },
    },
    {
        title: "开启流控",
        dataIndex: "authflag",
        customRender: text => (text == "1" ? "开启" : "关闭"),
        width:80
    },
    {
        title: '配置项',
        dataIndex: 'riskconfig',
        align: 'left',
        width: 240,
        scopedSlots: { customRender: 'riskconfigs' },
    },
    
    {
        title: '更新时间',
        dataIndex: 'updatetime',
        align: 'center'
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    },
];

const data = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            tLoading:true,
            searchAppcode:'',
            searchSyscode:'',
        };
    },
    methods: {
        handleDownConfig(record){
            let c_params = {
                appcode:record.appcode,
            }
            c_params.urlparams = false;
            let that = this;
            this.$store.dispatch({
                type: "servicekey/detailriskconfig",
                params:c_params
            }).then((res)=>{
                let result = res.data;
                result.success == '1' ? that.message.success("下发成功") :  that.message.error("下发失败");
            })
        },
        getAppList(cpage){
            this.tLoading = true;
            let c_params = {
                queryappcode:this.searchAppcode,
                syscode:this.searchSyscode
            }
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.$store.dispatch({
                type: "servicekey/queryAppriskconfig",
                params:c_params
            }).then((res)=>{
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.pagination.total = result.totalRecords;
                this.pagination.pageSize = result.pageSize;
                this.pagination.current = result.page;
            })
        },
        handlePageChange(c_p){
            this.getAppList(c_p)
        },
        handleAppSearch(){
            this.getAppList(1);
        },
        handleSearchAppcodeChange(value){
            this.searchAppcode = value;
        },
        handleSearchSyscodeChange(value){
            this.searchSyscode = value;
        },
        handleAppConfig(record){
            this.$router.push({
                path: "authappservice",
                query: {parentappcode:record.appcode}
            });
        },
        handleEditAppConfig(record){
            this.$router.push({
                path: "editappriskconfig",
                query: {id:record.id}
            });
        },
        handleNewAppRiskConfig(){
            this.$router.push({
                path: "addappriskconfig",
                query: {}
            });
        },
    
        handle_auth_delete(item){
            this.tLoading = true;
            this.$store.dispatch({
                type: "servicekey/deleteAppriskconfig",
                params:{id:item.id,urlparams:false}
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                if(res.data.success == '1'){
                    this.getAppList()
                }
            })
        },
    },
    components:{
        AppAutoComplete,
        authedStrd
    },
    mounted(){
        const { query, path } = this.$route;
        this.action = path.split("/").pop();
        this.searchAppcode = query.appcode ? query.appcode : '';
        this.$refs.appcodeAss.setInputVal(this.searchAppcode);

        this.getAppList(1);

    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
